import styled from 'styled-components';

export default styled.div`
	display: flex;
	align-items: center;
	justify-content: center;
	margin-top: 75px;
`;
